module.exports = __webpack_public_path__ + "img/img_pantalon.de4ce8c5.svg";